import React, { useEffect, useState } from 'react';
import { Form, Table } from 'react-bootstrap';

/* import context function */
import { CheckboxProvider, useCheckbox } from '../context/checkContext';

export const Header = ({ content, lists, totalList }) => {
    const { selected, checkboxHandler } = useCheckbox();
    
    const checked = lists?.filter(({ key }) => !selected.includes(key));
    
    return (
        <thead>
            <tr>
                {
                    content?.map(({key, type, value, colspan}, index) => {
                        if (type === 'checkbox') {
                            return (
                                <th key={`${key}-${index}`} colSpan={ colspan }>
                                    <Form.Check type="checkbox" className='form-checkbox' value='checked' checked={ !checked?.length } onChange={ checkboxHandler } />
                                </th>
                            );
                        }
                        return (
                            <th key={`${key}-${index}`} colSpan={ colspan }>{ value }</th>
                        );
                    })
                }
            </tr>
        </thead>
    );
}

export const Body = ({ content, colspan }) => {
    const hasContent = content && content?.length;
    
    return (
        <tbody>{ (!!hasContent && content) || <tr><td className='text-center' colSpan={ colspan }>尚無資料</td></tr> }</tbody>
    )
}

const TableElement = ({ header = [], body, bordered = false, presetSelect = [], presetContent = [], selectHandler}) => {
    const [selected, setSelected] = useState(presetSelect);
    const [selectContent, setContent] = useState(presetContent);
    let _colspan = header.length;
    
    const checkboxHandler = ({ target: { checked, value } }, content) => {
        const _selected = [...selected];
        const _content = [...selectContent];
        
        if (!checked) {
            if (value === 'checked') {
                _content.length = 0;
                _selected.length = 0;
            }
            else {
                const index = _selected.indexOf(value);
                const _index = _content.findIndex(({ mId }) => mId === value);

                _content.splice(_index, 1);
                _selected.splice(index, 1);
            }
        }
        else {
            if (value === 'checked') {
                body.forEach(({ key, props: { content } }) => {
                    const _filters = _content.filter(({ mId }) => mId === key);

                    (_filters.length || _content.push(content));
                    (_selected.includes(key) || _selected.push(key));
                });
            }
            else {
                _content.push(content);
                _selected.push(value);
            }
        }
        
        setContent(_content);
        setSelected(_selected);
    };

    header.filter(({ colspan }) => { colspan && (_colspan += (colspan - 1)) });
    
    useEffect(() => { selectHandler && selectHandler({ target: { name: 'mIds', value: selected, content: selectContent } }) }, [selected]);
    
    return (
        <CheckboxProvider checked={{ selected, checkboxHandler }}>
            <Table striped className='text-center' bordered={ bordered } hover>
                <Header content={ header } lists={ body } totalList={ body?.length } />
                <Body content={ body } colspan={ _colspan } />
            </Table>
        </CheckboxProvider>
    );
};

export default React.memo(TableElement);